
// mac chrome : Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"
// mac firefox : Mozilla/5.0 (Macintosh; Intel Mac OS X 10.12; rv:53.0) Gecko/20100101 Firefox/53.0"
// mac safari : Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_5) AppleWebKit/603.2.4 (KHTML, like Gecko) Version/10.1.1 Safari/603.2.4

//pc safari : Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/534.57.2 (KHTML, like Gecko) Version/5.1.7 Safari/534.57.2
//pc chrome : Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.81 Safari/537.36
//pc firefox : Mozilla/5.0 (Windows NT 6.1; WOW64; rv:53.0) Gecko/20100101 Firefox/53.0
//pc ie : Mozilla/5.0 (Windows NT 6.1; WOW64; Trident/7.0; SLCC2; .NET CLR 2.0.50727; .NET CLR 3.5.30729; .NET CLR 3.0.30729; Media Center PC 6.0; InfoPath.3; .NET4.0C; .NET4.0E; rv:11.0) like Gecko 

//iphone : Mozilla/5.0 (iPhone; CPU iPhone OS 7_1_2 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Mobile/11D257 MicroMessenger/6.5.4 NetType/4G Language/zh_CN
//Android :  Mozilla/5.0 (Linux; Android 6.0; MI 5 Build/MRA58K; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/53.0.2785.49 Mobile MQQBrowser/6.2 TBS/043220 Safari/537.36 MicroMessenger/6.5.8.1060 NetType/4G Language/zh_CN

'use strict';

const userAgent = navigator.userAgent;

var	kernel = function(){
	var k;
	
	if(userAgent.indexOf('Trident') > -1){//IE内核  
		k = 'ie';
	}
	if(userAgent.indexOf('Presto') > -1){//opera内核 
		k = 'opera';
	}
	if(userAgent.indexOf('AppleWebKit') > -1){//苹果、谷歌内核  
		if(userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1){
			k = 'chrome';
		}else if(userAgent.indexOf('Safari') > -1){
			k = 'safari';
		}else{
			k = 'other';
		}
	}
	if(userAgent.indexOf('Firefox') > -1){//火狐内核  
		k = 'firefox';
	}
	
	return k;
};

var	terminal = function(){
	var t;
	
	if(userAgent.indexOf('Android') > -1){
		t = 'Android';
	}else if(userAgent.indexOf('iPad') > -1){
		t = 'iPad';
	}else if(userAgent.indexOf('iPhone') > -1){
		t = 'iPhone';
	}else if(userAgent.indexOf('Macintosh') > -1){
		t = 'Macintosh';
	}else{
		t = 'pc';
	}
	
	return t;
};

export {kernel, terminal};


// WEBPACK FOOTER //
// ./src/performance/browser.js